<template>
  <div class="relative z-index-500 center-items-x pa-1 ml-3 mr-3 mt-3 pt-3">
    <div class="spacer"></div>

    <div class="medium title-2 mb-1 mr-1 mt-3 pt-3">
      Te enviaremos un correo electrónico,
      <br />para reconfigurar la
      <br />contraseña
    </div>

    <form class="mr-2 mt-2 mb-1">
      <div class="medium normal">Correo Electrónico</div>
      <input
        v-model="payload.clientEmail"
        class="bizel border-line-2 height-50 border-line-2 reverse normal mb-1 pl-2"
        placeholder="admin@complex.com.co"
        type="email"
        autocomplete="email"
      />
    </form>

    <div v-if="!sendOK" @click.stop="ResetEmail" class="mb-3 row medium uppercased normal">
      <div class="bizel back1 height-50 theme center-items pr-3 pl-3 col isButton">Continuar</div>
      <div class="spacer row"></div>
    </div>

    <div v-else class="mb-3 row  medium uppercased normal">
      <div class="bizel green height-50 theme center-items pr-3 pl-2 col isButton">
        <div>
          <span class="mdi mdi-check mr-1"></span>
          <span>correo enviado</span>
        </div>
      </div>
      <div class="spacer row"></div>
    </div>

    <div class="spacer"></div>
    <div class="spacer"></div>
    <div class="spacer"></div>
  </div>
</template>
<script>
import firebase from "../plugins/firebase";
export default {
  data: () => ({
    sendOK: false,
    payload: {
      clientEmail: ""
    }
  }),
  methods: {
    ResetEmail() {
      if (this.payload.clientEmail != "") {
        firebase
          .auth()
          .sendPasswordResetEmail(this.payload.clientEmail)
          .then(() => {
            this.sendOK = true;
            this.payload.clientEmail = "";
          })
          .catch(error => {
            alert(error.message);
          });
      }
    }
  }
};
</script>
<style scoped>
.efect {
  transition: 0.6s ease;
}
</style>